import { fromJS } from 'immutable';
import { createAction, handleActions } from 'redux-actions';
import { message } from 'antd';
import { toggleLoadingMask } from 'modules/global';

const GET_HOTELS_SUCCESS = 'modules/Global/GET_HOTELS_SUCCESS';

const initialState = fromJS({
  data: {
    hotels: {},
  },
});

const reducer = handleActions({
  [GET_HOTELS_SUCCESS]: (state, { payload }) => {
    return state.setIn(['data', 'hotels'], fromJS(payload.hotels));
  },
}, initialState);

const getHotelsSuccess =
    createAction(
      GET_HOTELS_SUCCESS,
      (hotels) => {
        return { hotels };
      },
    );

export const getHotels = () => {
  return async function (dispatch, getState, { api }) {
    dispatch(toggleLoadingMask());
    // const state = getState();
    // const conference = state.getIn(['global', 'data', 'conference', 'id']);
    try {
      const response = await api.get('/hotels/', { params: { conference: '0o10q1w' } });
      dispatch(getHotelsSuccess(response.data));
      dispatch(toggleLoadingMask());
    } catch (err) {
      message.error(err.message);
      dispatch(toggleLoadingMask());
    }
  };
};

export default reducer;



// WEBPACK FOOTER //
// ./src/modules/hotels.js